
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/raccolte/[slug]",
      function () {
        return require("private-next-pages/raccolte/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/raccolte/[slug]"])
      });
    }
  